module.exports = __webpack_public_path__ + "img/tractive.972efecd.png";